import { Object3D } from 'three';

/**
 * Whether the object and its ancestors are visible, up to the root (not included) if there is one.
 * Raycasters intersect hidden objects too, and an object is hidden when an ancestor is.
 */
export function isShownBelow(object: Object3D, root?: Object3D | null): boolean {
  for (let x: Object3D | null = object; x && x !== root; x = x.parent) {
    if (!x.visible) {
      return false;
    }
  }

  return true;
}
